// extracted by mini-css-extract-plugin
export default {"fr-view":"CourseItem_fr-view__sObNR","container":"CourseItem_container__AFDmg","icon":"CourseItem_icon__EZoXn","title":"CourseItem_title__OET-B"};